import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeedTimeline from './components/FeedTimeline';
import HowTo from './components/HowTo';
import GuideCollection from './components/GuideCollection';
import Tips from './components/Tips';
import Rules from './components/Rules';
import Faq from './components/Faq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <FeedTimeline />
        <HowTo />
        <GuideCollection />
        <Tips />
        <Rules />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}